var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAnnouncementActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 53 53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_58",
    "data-name": "Group 58",
    transform: "translate(-20 -21)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_13",
    "data-name": "Ellipse 13",
    cx: 26.5,
    cy: 26.5,
    r: 26.5,
    transform: "translate(20 21)",
    fill: "#438dc1",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "svg-group-circle-path",
    id: "announcement-8",
    d: "M48.864,58.069l-.6-.458a2.176,2.176,0,0,1-.641-1.832V54.451a.7.7,0,0,0-.687-.687H44.193a.7.7,0,0,0-.687.687v3.526a1.975,1.975,0,0,0,1.878,2.2h2.244c1.328,0,1.42-.916,1.42-.916s.229-.824-.183-1.191ZM59.076,45.521V39.247a1.2,1.2,0,0,0-2.107-.687l-4.076,3.847a3.474,3.474,0,0,1-2.29.779H43.644a4.451,4.451,0,0,0-4.259,4.488v.092a4.146,4.146,0,0,0,4.259,4.167H50.6a3.636,3.636,0,0,1,2.336.916l4.03,3.938c.733.733,2.107.458,2.107-.641V49.917a2.2,2.2,0,1,0,0-4.4Z",
    transform: "translate(-3.83 -1.67)",
    fill: "#61BB46"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAnnouncementActive);
export default __webpack_public_path__ + "static/media/icon-announcement-active.cded1748c5774794d7f3c2a89350bd10.svg";
export { ForwardRef as ReactComponent };